module.exports = __webpack_public_path__ + "img/3-1.f7b65d9d.png";